import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

const { persistAtom } = recoilPersist()

export const openConsoleState = atom({
    key: 'open-console',
    default: false,
})

export const maximizeConsoleState = atom({
    key: 'maximize-console',
    default: false,
})

// Store websocket events
export const websocketState = atom({
    key: 'websocket-events',
    default: [],
    effects: [persistAtom],
})